import { actionTextColor } from "../../utils/themeContrast";
import React from "react";
import styled from "@emotion/styled";
import { ThemeContext, UserContext, LanguageContext } from "../../contexts/Context";
import { lightTint, readableText } from "../../utils/themeContrast";

const Modal = ({ show, setShow, confirmCheckOut, lanIndex }) => {
  const theme = React.useContext(ThemeContext);
  const { cart = [] } = React.useContext(UserContext);
  const language = React.useContext(LanguageContext)[lanIndex];
  const count = cart.reduce((total, item) => total + Number(item.qty || 0), 0);
  if (!show) return null;
  return <DialogBackdrop onClick={() => setShow(false)}>
    <DialogCard themeContext={theme} role="dialog" aria-modal="true" aria-label={language.lockRound} onClick={event => event.stopPropagation()} onKeyDown={event => { if (event.key === "Escape") setShow(false); }}>
      <DialogTitle>{language.lockRound}</DialogTitle>
      <DialogDescription>{(count === 1 ? language.roundSendOne : language.roundSendMany).replace("{count}", count)}</DialogDescription>
      <DialogActions>
        <DialogButton autoFocus type="button" themeContext={theme} onClick={() => setShow(false)}>{language.keepEditing}</DialogButton>
        <DialogButton type="button" primary themeContext={theme} onClick={() => { setShow(false); confirmCheckOut(); }}>{language.sendToKitchen}</DialogButton>
      </DialogActions>
    </DialogCard>
  </DialogBackdrop>;
};
export default Modal;
export const DialogBackdrop = styled.div`
  position: fixed; inset: 0; z-index: 11000; display: flex; align-items: center; justify-content: center;
  padding: 20px; box-sizing: border-box; background: rgba(0,0,0,.48);
`;
export const DialogCard = styled.div`
  width: 100%; max-width: 360px; max-height: calc(100dvh - 40px); overflow-y: auto;
  box-sizing: border-box; padding: 20px 18px 18px; border-radius: 18px;
  background: ${p => p.themeContext.backgroundColor || '#fff'};
  color: ${p => readableText(p.themeContext.backgroundColor, p.themeContext.fontPrimary)};
  font-family: ${p => p.themeContext.fontFamily};
  border: 1px solid rgba(128,128,128,.15); box-shadow: 0 16px 48px rgba(0,0,0,.18);
`;
export const DialogTitle = styled.h2`
  margin: 0; font-size: 16px; line-height: 1.4; font-weight: 700; text-align: left;
`;
export const DialogDescription = styled.div`
  margin-top: 8px; font-size: 13px; line-height: 1.55; opacity: .8; text-align: left; overflow-wrap: anywhere;
`;
export const DialogActions = styled.div`
  display: flex; gap: 8px; margin-top: 16px;
`;
export const DialogButton = styled.button`
  flex: 1; min-width: 0; min-height: 44px; padding: 10px 12px; border-radius: 999px;
  border: 1px solid ${p => p.primary ? p.themeContext.primaryColor : lightTint(p.themeContext.primaryColor, .24)};
  background: ${p => p.primary ? p.themeContext.primaryColor : p.themeContext.backgroundColor};
  color: ${p => p.primary ? actionTextColor(p.themeContext) : readableText(p.themeContext.backgroundColor, p.themeContext.fontPrimary)};
  font: inherit; font-size: 13px; font-weight: 600; line-height: 1.3; cursor: pointer;
  &:focus-visible { outline: 2px solid ${p => p.themeContext.primaryColor}; outline-offset: 2px; }
`;
